import { FlowType } from '@ace-clublabs/common-membership-api-types';

/**
 * Flows that share the B2B Major Rocket behavior: same payment config version, member rules,
 * page navigation, flow content, and analytics tags.
 */
export const B2B_MAJOR_ROCKET_FLOWS: FlowType[] = [FlowType.B2B_MAJOR_ROCKET, FlowType.B2B_W_INSURANCE_AGENT];

export const isB2bMajorRocketFlow = (flow?: string | null): boolean =>
  B2B_MAJOR_ROCKET_FLOWS.includes(flow as FlowType);
